<template>
  <div class="form-group">
    <div class="grey mb5">{{ label ?? name }}</div>
    <div class="box-pick">
      <div class="color-picker showed">
        <label for="colorPicker" class="d-flex align-items-center text-uppercase grey">
          <input type="color" id="colorPicker" v-model="inputValue" ref="picker" :name="name" :placeholder="placeholder"
            v-validate="rules" :disabled="disabled">
          <span>{{ inputValue }}</span>
        </label>
      </div>
      <div>
        <button @click="$refs.picker.click()" class="btn btn-for-pick">Select color</button>
      </div>
    </div>
    <small class="text-danger text-sm" v-show="errors.has(name)">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'FieldColorPicker',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    parentClass: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator']
};
</script>
